import React from "react";

function Privacy() {
  return (
    <div style={{ padding: "40px", maxWidth: 900, margin: "0 auto", fontFamily: "Arial, sans-serif" }}>
      <h1>Privacy Policy</h1>
      <p>This Privacy Policy describes how <strong>ResumeFuel</strong> collects, uses, and protects your personal information.</p>

      <h2>1. What We Collect</h2>
      <ul>
        <li>Name, email, phone number, and job-related information (e.g., education, experience, skills).</li>
        <li>Login credentials if you register an account.</li>
        <li>Payment details (handled by third-party gateways like PayPal or Razorpay).</li>
        <li>Usage data, such as browser type, pages visited, and IP address, for analytics.</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To generate and store your resume/CV data.</li>
        <li>To personalize your experience and improve our services.</li>
        <li>To process payments securely.</li>
        <li>To communicate with you regarding your account or support requests.</li>
      </ul>

      <h2>3. Data Security</h2>
      <p>We implement industry-standard encryption and secure practices to protect your data. Access is restricted to authorized personnel only.</p>

      <h2>4. Sharing of Information</h2>
      <p>We do not sell or rent your personal data. We may share limited information with trusted third-party services (e.g., payment gateways, hosting providers) only as needed to provide the service.</p>

      <h2>5. Cookies and Tracking</h2>
      <p>We use cookies to enhance site performance and collect anonymized analytics via tools like Google Analytics. You can manage cookies in your browser settings.</p>

      <h2>6. Your Rights</h2>
      <ul>
        <li>You can request access to your data at any time.</li>
        <li>You may request deletion of your data or account by contacting us.</li>
        <li>You can opt out of non-essential communications.</li>
      </ul>

      <h2>7. Changes to Policy</h2>
      <p>We may update this policy from time to time. Updates will be posted on this page with a revised effective date.</p>

      <h2>8. Contact Us</h2>
      <p>If you have questions about this Privacy Policy, please contact us.</p>
    </div>
  );
}

export default Privacy;
